import axios, { AxiosResponse } from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { TitlesFootnotesReadDto } from "../tlfItem/TitlesFootnotesReadDto";
import { HierarchyQueryParams } from "./HierarchyQueryParams";

export type ITlfTifoReturn = IAxiosReturn<TitlesFootnotesReadDto[]>;

/**
 * Load titles and footnotes (TIFOs) for a hierarchy's TLFs.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchy - Query parameters identifying the hierarchy
 * @param controller - Optional AbortController
 * @returns Titles and footnotes wrapped in ITlfTifoReturn
 */
export const loadHierarchyTlfTifos = async (
  backEndUrl: string,
  hierarchy: HierarchyQueryParams,
  controller?: AbortController,
): Promise<ITlfTifoReturn> => {
  const url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}/TitlesFootnotes`;
  // Get data
  try {
    const response: AxiosResponse = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );

    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load hierarchy tifos failed", error);
  }
};
